import React, { memo } from 'react';
import { Icon } from '../icon';
import { FallbackContainer, FallbackWrapper, FallbackContent, Title } from './styled';
export const WidgetFallback = memo(({ children, title, hideIcon }) => {
    return (React.createElement(React.Fragment, null,
        title && React.createElement(Title, null, title),
        React.createElement(FallbackWrapper, null,
            React.createElement(FallbackContainer, { withTitle: Boolean(title) },
                !hideIcon && (React.createElement(Icon, { name: "warning_amber", size: "xlarge", "data-testid": "widget-fallback-icon" })),
                React.createElement(FallbackContent, null, children)))));
});
